import { render, staticRenderFns } from "./AddLicenceModal.vue?vue&type=template&id=20a89ad0"
import script from "./AddLicenceModal.vue?vue&type=script&lang=ts"
export * from "./AddLicenceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports